import { render, staticRenderFns } from "./TimesCard.vue?vue&type=template&id=18553f21&scoped=true&"
import script from "./TimesCard.vue?vue&type=script&lang=js&"
export * from "./TimesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18553f21",
  null
  
)

export default component.exports